<obg-m-dialog-layout
	#dialog
	[titleText]="'casino-block.select-player-profile.title' | jurisdiction"
	[dialogId]="dialogId"
	hideFooter="true"
>
	<form (submit)="confirmSelection()">
		<obg-m-select-player-profile [(playerProfile)]="playerProfile"></obg-m-select-player-profile>
		<div class="obg-m-select-player-profile-dialog-buttons">
			<button type="submit" mat-flat-button color="primary" [disabled]="isConfirmDisabled()">
				{{ 'general.confirm' | translate }}
			</button>
			<button type="button" mat-button (click)="askMeLater()">{{ 'general.ask-me-later' | translate }}</button>
		</div>
	</form>
	<div class="obg-m-select-player-profile-dialog-footer">
		{{ 'casino-block.select-player-profile.footer' | jurisdiction | translate }}
	</div>
</obg-m-dialog-layout>
